module.exports = __webpack_public_path__ + "static/Regulamin_e_containers_eu_pl-7d397bcb422832eaef9597f93e3c6424.pdf";